import React, { Component } from 'react';
import PropTypes from 'prop-types';

import  './Checkbox.scss';

class CheckBox extends Component {
  static defaultProps = {
    onChange: function () {},
  };

  constructor(props) {
    super(props);
    this.state = {
      value: undefined,
    };
  }

  componentDidMount() {
    this.setState({
      value: this.props.value,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value != this.props.value) {
      this.setState({
        value: this.props.value,
      });
    }
  }

  handleColorChange = (color) => {
    if (typeof this.props.onColorChange === 'function') {
      this.props.onColorChange({
        optId: this.state.value,
        color,
      });
    }
  };

  handleChange = (e) => {
    const { checked, name } = e.target;
    this.props.onChange({ name, checked, value: this.state.value });
  };

  render() {
    const { name, className, checked, label, id, disabled, colorsChangable, ItemRenderer, rendererValues } = this.props;
    const tooltipTitle = typeof label === 'string' ? label : undefined;

    return (
      <label className={`check_box ${className ? className : ''} ${disabled ? 'disabled' : ''}`}>
        <div className='checkbox_label' title={tooltipTitle}>
          {ItemRenderer ? (
            <ItemRenderer
              colorsChangable={colorsChangable}
              label={label}
              option={rendererValues}
              onColorChange={this.handleColorChange}
            />
          ) : (
            label
          )}
        </div>
        <input name={name} id={id} checked={checked} type="checkbox" onChange={this.handleChange} disabled={disabled} />
        <span className='checkmark'>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="none">
            <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" />
          </svg>
        </span>
      </label>
    );
  }
}

CheckBox.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  label: PropTypes.node.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  ItemRenderer: PropTypes.func,
  rendererValues: PropTypes.object,
  colorsChangable: PropTypes.bool,
  ItemRenderer: PropTypes.func,
  onColorChange: PropTypes.func,
};

export default CheckBox;
